import {ContentBlockMetadataRestDto, JsonContentRestDto} from "@/api/pharma-cms-content-block/models";
import {NormalContentBlockModel} from "@/models/api/pharma-cms-content-block/NormalContentBlockModel";
import {StatusEnum} from "@/api/enums/status-enum";

export class JsonContentRestDtoModel extends NormalContentBlockModel implements JsonContentRestDto {
    cb_metadata?: ContentBlockMetadataRestDto;
    content: object | null;
    sort_weight?: number;
    status_code: StatusEnum;

    constructor(content: object | null, status_code: StatusEnum) {
        super();
        this.content = content;
        this.status_code = status_code;
    }

    static createWithDefaults(): JsonContentRestDtoModel {
        return new this(null, StatusEnum.PUBLISHED);
    }
}
